import React, { useState, useEffect } from "react";
import withMainLayout from "../HOC/withMainLayout";
import { Link } from "react-router-dom";
import browserRoute from "../../Routes/browserRoutes";
import Images from "../Helper/AllImages";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { NGROK } from "../../Services/mainServices";
import { SET_NOTIFICATIONS_DATA } from "../../Redux/actions/types";

const data = [
  {
    title: "Login attempted from new IP",
    date: "2021-03-10 20:19:15",
    body: "Hello, youve reset the Google Authentication on your account successfully. Your old security items have expired and new security items have now been enabled",
  },
  {
    title: "Login attempted from new IP",
    date: "2021-03-10 20:19:15",
    body: "Hello, youve reset the Google Authentication on your account successfully. Your old security items have expired and new security items have now been enabled",
  },
  {
    title: "Login attempted from new IP",
    date: "2021-03-10 20:19:15",
    body: "Hello, youve reset the Google Authentication on your account successfully. Your old security items have expired and new security items have now been enabled",
  },
  {
    title: "Login attempted from new IP",
    date: "2021-03-10 20:19:15",
    body: "Hello, youve reset the Google Authentication on your account successfully. Your old security items have expired and new security items have now been enabled",
  },
  {
    title: "Login attempted from new IP",
    date: "2021-03-10 20:19:15",
    body: "Hello, youve reset the Google Authentication on your account successfully. Your old security items have expired and new security items have now been enabled",
  },
  {
    title: "Login attempted from new IP",
    date: "2021-03-10 20:19:15",
    body: "Hello, youve reset the Google Authentication on your account successfully. Your old security items have expired and new security items have now been enabled",
  },
];

function Notifications() {
  const [notificationsData, setNotificationsData] = useState([]);
  const nData = useSelector((state) => state.main.notificationData);
  const keyStoreClient = useSelector((state) => state.main.KeyStoreClient);
  const dispatch = useDispatch();
  const loggedIn = useSelector((state) => state.main.isLoggedin);

  const getNotificationsData = async () => {
    const add = keyStoreClient.map((d) => d.Address);
    const data = {
      clients: add,
    };

    const extractTID = nData
      ?.filter((d) => d.isVisited == false)
      .map((e) => e._id);

    console.log("__________NOTIFICATIONS ADDRESSS _____ ", add);
    console.log("__________ <><><><>ONLY IDSS<><<><>< _____ ", extractTID);
    // for (let i = 0; i < keyStoreClient?.length; i++) {
    axios
      .post(`${NGROK}/get/client/transactions`, data)
      .then(
        (e) => (
          dispatch({
            type: SET_NOTIFICATIONS_DATA,
            payload: {
              notificationData: e?.data,
            },
          }),
          setNotificationsData(e?.data?.reverse()),
          console.log("__________NOTIFICATIONS DATA_____ ", e?.data)
        )
      )
      .catch((e) => console.log("______ERR Notifications______ ", e));
  };

  useEffect(() => {
    if (nData?.length) {
      setNotificationsData(nData);
    }
  }, [nData]);

  useEffect(() => {
    if (loggedIn) {
      if (notificationsData?.length > 0) {
        const extractTID = nData
          ?.filter((d) => d.isVisited == false)
          .map((e) => e._id);

        const data = {
          transactionIds: extractTID,
        };

        console.log("TID >>><<<<>>>>> ", data);

        axios
          .post(`${NGROK}/update/isvisited`, data)
          .then((res) => {
            console.log(
              "RESSSSS =<><><><<ISVISITED><><><><><><<><><><>>< ",
              res?.data
            );
            getNotificationsData();
          })
          .catch((e) => console.log("ERR GETTING NOTIFICATIONS ><<>", e));
      }
    }
  }, []);

  return (
    <>
      <section
        style={{ backgroundColor: "#F4F5F6" }}
        class="n-notificationsSection"
      >
        <div className="container pt-4 pb-4 pr-4 pl-4 n-notificationPage">
          <div className="row">
            <div className="col-lg-12 d-flex justify-content-between">
              <h2 className="u-notificatiomnheadinfg099">Notifications</h2>
              <div class=" d-flex form-group has-search mb-0 n-inputSearch">
                <input
                  style={{
                    borderRadius: "100px",
                    backgroundColor: "#fcfcfd",
                  }}
                  type="text"
                  class="form-control n-tableSearch n-responsiveSearch n-tableSeachDark"
                  placeholder="Search"
                />
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    width: "20px",
                    height: "20px",
                    marginLeft: "-35px",
                    marginBottom: "10px",
                  }}
                  class="marketSearchIcon"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.4207 13.6002C11.2918 14.4778 9.87327 15.0003 8.33268 15.0003C4.65078 15.0003 1.66602 12.0156 1.66602 8.33366C1.66602 4.65176 4.65078 1.66699 8.33268 1.66699C12.0146 1.66699 14.9993 4.65176 14.9993 8.33366C14.9993 9.87425 14.4768 11.2928 13.5992 12.4217L18.0886 16.9111C18.414 17.2365 18.414 17.7641 18.0886 18.0896C17.7632 18.415 17.2355 18.415 16.9101 18.0896L12.4207 13.6002ZM13.3327 8.33366C13.3327 11.0951 11.0941 13.3337 8.33268 13.3337C5.57126 13.3337 3.33268 11.0951 3.33268 8.33366C3.33268 5.57224 5.57126 3.33366 8.33268 3.33366C11.0941 3.33366 13.3327 5.57224 13.3327 8.33366Z"
                    fill="#777E91"
                  />
                </svg>

                {/* <span
                      style={{ paddingTop: "10px", marginLeft: "-27px" }}
                      class=" fa fa-search form-control-feedback"
                    ></span> */}
              </div>
            </div>
            {/* <div className="col-lg-4">
              <div className="d-flex justify-content-end">
                <button class="n-primaryButton n-primaryDark">View all</button>
                <button
                  class="n-secondaryButton ml-2"
                  onClick={() => setNotificationsData("")}
                >
                  Clear all
                </button>
              </div>
            </div> */}
          </div>
          <hr className="solid n-notificationSeprator" />
          <div className="row">
            <div className="col-lg-12">
              <div className="row" style={{ minHeight: "60vh" }}>
                <div className="col-lg-12">
                  {notificationsData?.length > 0 ? (
                    notificationsData?.map((e) => (
                      <div>
                        <div className="d-flex flex-row justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <div className="n-swapButton">
                              Swap
                            </div>
                            <p className="u-notificationheadinf4555">60 Rune</p>
                            <svg
                              width="28"
                              height="28"
                              viewBox="0 0 28 28"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                marginLeft: "40px",
                                marginRight: "40px",
                              }}
                            >
                              <circle
                                cx="14"
                                cy="14"
                                r="13"
                                stroke="#000000"
                                stroke-width="2"
                              />
                              <path
                                d="M13.1604 9.15032L13.7153 8.58096C13.9503 8.33988 14.3303 8.33988 14.5628 8.58096L19.4222 13.5641C19.6572 13.8052 19.6572 14.1951 19.4222 14.4336L14.5628 19.4193C14.3278 19.6604 13.9478 19.6604 13.7153 19.4193L13.1604 18.85C12.9229 18.6063 12.9279 18.2088 13.1704 17.9703L16.1826 15.026H8.99837C8.66591 15.026 8.39844 14.7516 8.39844 14.4105V13.5898C8.39844 13.2487 8.66591 12.9743 8.99837 12.9743H16.1826L13.1704 10.03C12.9254 9.79149 12.9204 9.39396 13.1604 9.15032Z"
                                fill="#000000"
                              />
                            </svg>
                            {/* <img src={Images.iconsrightline}/> */}
                            <p className="u-notificationheadinf4555">
                              {e.amount} {e.coin}
                            </p>
                          </div>
                          <div className="d-flex justify-content-between align-items-center" style={{width: "375px"}}>
                            <button
                              type="button"
                              class="n-secondaryButton n-ButtonResponsive u-marginclasss44555"
                              style={{ float: "right", marginRight: "0"}}
                            >
                              View transaction
                            </button>
                            <p
                              className="datecalsssnotification88"
                              style={{ marginRight: "40px" }}
                            >
                              {e.date.substring(0, 24)}
                            </p>
                            {!e.isVisited && (
                              <img
                                className="u-notificationaimages4444"
                                src={Images.notificationdot}
                              />
                            )}
                          </div>
                        </div>
                        <hr className="solid n-notificationSeprator2" />
                      </div>
                    ))
                  ) : (
                    <>
                      <div class="datecalsssnotification88">
                        No notifications available
                      </div>
                      <div class="w-no-data-tb"></div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {/* <div className="col-lg-12">
              <div className="d-flex flex-row justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <button className="n-primaryButton n-primaryDark">
                    Swap
                  </button>
                  <p className="u-notificationheadinf4555">60 Rune</p>
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ marginLeft: "40px", marginRight: "40px" }}
                  >
                    <circle
                      cx="14"
                      cy="14"
                      r="13"
                      stroke="#777e90"
                      stroke-width="2"
                    />
                    <path
                      d="M13.1604 9.15032L13.7153 8.58096C13.9503 8.33988 14.3303 8.33988 14.5628 8.58096L19.4222 13.5641C19.6572 13.8052 19.6572 14.1951 19.4222 14.4336L14.5628 19.4193C14.3278 19.6604 13.9478 19.6604 13.7153 19.4193L13.1604 18.85C12.9229 18.6063 12.9279 18.2088 13.1704 17.9703L16.1826 15.026H8.99837C8.66591 15.026 8.39844 14.7516 8.39844 14.4105V13.5898C8.39844 13.2487 8.66591 12.9743 8.99837 12.9743H16.1826L13.1704 10.03C12.9254 9.79149 12.9204 9.39396 13.1604 9.15032Z"
                      fill="#777e90"
                    />
                  </svg>
                   <img src={Images.iconsrightline}/>
                  <p className="u-notificationheadinf4555">0.0054 BTC</p>
                </div>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    class="n-secondaryButton n-ButtonResponsive u-marginclasss44555"
                    style={{ float: "right" }}
                  >
                    View transaction
                  </button>
                  <p
                    className="datecalsssnotification88"
                    style={{ marginRight: "40px" }}
                  >
                    2021-03-10 20:19:15
                  </p>
                  <img
                    className="u-notificationaimages4444"
                    src={Images.notificationdot}
                  />
                </div>
              </div>
              <hr className="solid n-notificationSeprator2" />
              <div class="w-no-data-tb"></div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default withMainLayout(Notifications);
